import { styled } from '@mui/system';
import { Skeleton } from '@mui/material';

const CardSkeleton = styled('a')<{ listLength: number }>(
  ({ theme, listLength }) => ({
    width: '200px',
    minWidth: '151px',
    minHeight: '199px',
    border: '1px solid #EAEAEA',
    borderWidth: '0px 1px 1px 0px',
    textDecoration: 'none',
    scrollSnapAlign: 'start',
    position: 'relative',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    padding: '17px 15px',
    [theme.breakpoints.up(320)]: {
      width: `${Math.max(100 / listLength, 50)}%`,
      minWidth: 150,
    },

    [theme.breakpoints.up(470)]: {
      width: `${Math.max(100 / listLength, 33.3)}%`,
    },
    [theme.breakpoints.up(620)]: {
      width: `${Math.max(100 / listLength, 25)}%`,
    },
    [theme.breakpoints.up(770)]: {
      width: listLength > 3 ? '33.3%' : 200,
      minWidth: 200,
    },
    [theme.breakpoints.up(820)]: {
      width: listLength > 4 ? '25%' : 200,
    },

    [theme.breakpoints.up(1020)]: {
      width: listLength > 5 ? '20%' : 200,
    },

    [theme.breakpoints.up(1220)]: {
      width: 200,
    },
  }),
);

const StyledSkeleton = styled(Skeleton)`
  margin-bottom: 5px;
  padding: 0px;
`;

const MarginSkeleton = styled(Skeleton)`
  margin: 15px 0px;
`;

export { CardSkeleton, StyledSkeleton, MarginSkeleton };
